import React from 'react';

export interface Props {
  color?: string;
}

const Spinner: React.FC<Props> = ({ color }) => {
  const defaultColor = '#808080';

  return (
    <>
    <div className="overlay fixed left-0 top-0 z-[100] h-full w-full bg-gray-800 opacity-75"></div>
    <div className="fixed left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2 transform">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="88px"
        height="88px"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
      >
        <circle
          cx="50"
          cy="50"
          r="32"
          stroke-width="8"
          stroke="#A9A9A9"
          stroke-dasharray="50.26548245743669 50.26548245743669"
          fill="none"
          stroke-linecap="round"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            dur="1s"
            repeatCount="indefinite"
            keyTimes="0;1"
            values="0 50 50;360 50 50"
          ></animateTransform>
        </circle>
        <circle
          cx="50"
          cy="50"
          r="23"
          stroke-width="8"
          stroke="#A9A9A9"
          stroke-dasharray="36.12831551628262 36.12831551628262"
          stroke-dashoffset="36.12831551628262"
          fill="none"
          stroke-linecap="round"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            dur="1s"
            repeatCount="indefinite"
            keyTimes="0;1"
            values="0 50 50;-360 50 50"
          ></animateTransform>
        </circle>
      </svg>
    </div>
    </>
  );
};

export default Spinner;
